module.exports = __webpack_public_path__ + "img/ksQRCode.79ee27ae.jpg";